import { IAppState } from "../state";

export const routeSelector = (appState: IAppState) => appState.route;